import { ArticleDataObject } from "@app/types/Cue";
import BasicCard from "@components/ArticleCard/BasicCard";
import { CardVariations } from "@components/ArticleCard/types";
import { isArticleUpdated, parseStoryThread } from "@util/helpers";
import cx from "classnames";

export default function BreakingNewsStories({
  article,
  index,
  disablePaywall = false,
}: {
  article: ArticleDataObject;
  index: number;
  disablePaywall?: boolean;
}): React.ReactElement {
  const variant: CardVariations = {
    kicker: {
      color: "text-gray-515",
    },
    title: {
      color: "text-gray-850",
      size: "text-base",
    },
  };
  const storyThread = parseStoryThread(article.others?.storyThread);

  return (
    <div
      className={cx("story border-b border-gray-175 py-3 lg:col-span-1", {
        "lg:order-1": index < 2,
        "lg:order-3": index >= 2,
        "lg:mr-3": index === 1 || index === 3,
        "lg:border-none": index === 4 || index === 5 || index === 6,
        "border-none lg:border-b": index === 6,
      })}
    >
      <BasicCard
        id={article.id}
        slug={article.slug}
        title={article.displaySetting?.displayHeadline || article.title}
        kicker={article.kicker?.fields?.[0]?.value}
        section={article?.sections?.[0]}
        storyThread={storyThread}
        paywall={
          !disablePaywall ? article.paywall?.contentAccess === "1" : false
        }
        variations={variant}
        rootClassName={cx("h-full border-gray-175", {
          "lg:border-r lg:pr-3": [0, 2, 4, 5].includes(index),
          "lg:pl-3": [1, 3, 5, 6].includes(index),
          "lg:pr-3": [1, 3].includes(index),
        })}
        edited={
          isArticleUpdated(article.updated, article.edited)
            ? article.edited
            : undefined
        }
        updated={article.updated}
        hasUpdatedTimestampDisplay={
          article.displaySetting?.hasUpdatedTimeDisplayed
        }
      />
    </div>
  );
}
